import React from "react";

import MainLayout from "components/MainLayout";
import MainList from "components/MainList";

import CreateWorkerInvitationModal from "components/create_modals/CreateWorkerInvitationModal";
import columns from "./columns";
import WorkerTabs from "components/WorkerTabs";

const UsersList = () => {
  return (
    <MainLayout
      breadcrumbs={[{ name: "Administratorzy" }]}
      buttons={<CreateWorkerInvitationModal user_type="User::User" />}
    >
      <WorkerTabs current="users" />
      <MainList
        columns={columns}
        query_name="users"
        query_path="/users"
        query_context="index"
        default_sort="created_at__asc"
      />
    </MainLayout>
  );
};

export default UsersList;
